export default {};
export const CARD_DATA = {
  name: 'Card Data',
  fields: [{
    id: 'cardNumber',
    configProps: {
      title: 'Card Number',
    },
    selectedType: 'text',
  }],
};
